import React from 'react'
import '../css/page.css'
import Lottie from 'lottie-react'
import anTest from '../assets/devAnimation.json'
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'
import {
  BiLogoReact, BiLogoNodejs, BiLogoTypescript,
} from 'react-icons/bi'
import { FaAws } from 'react-icons/fa'
import { SiMysql } from 'react-icons/si'
import { Link } from 'react-scroll'
import DotGrid from './bits/DotGrid'
import { useT } from '../context/LanguageContext'

const STACK = [
  { icon: BiLogoReact,      label: 'React',        color: '#61DAFB' },
  { icon: BiLogoNodejs,     label: 'Node.js',       color: '#68A063' },
  { icon: BiLogoTypescript, label: 'TypeScript',    color: '#3178C6' },
  { icon: FaAws,            label: 'AWS',           color: '#FF9900' },
  { icon: BiLogoReact,      label: 'React Native',  color: '#61DAFB' },
  { icon: SiMysql,          label: 'SQL',           color: '#4479A1' },
]

function StackPill({ icon: Icon, label, color, delay }) {
  return (
    <div
      className="flex items-center gap-1.5"
      style={{
        padding: '4px 10px',
        borderRadius: 999,
        border: '1px solid rgba(255,255,255,0.08)',
        backgroundColor: 'rgba(255,255,255,0.03)',
        opacity: 0,
        animation: `fadeIn 0.4s ease ${delay}ms forwards`,
      }}
    >
      <Icon style={{ color, fontSize: 14, flexShrink: 0 }} />
      <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', fontFamily: 'Manrope, sans-serif', whiteSpace: 'nowrap' }}>
        {label}
      </span>
    </div>
  )
}

function Page() {
  const { t } = useT()

  return (
    <div className="home">

      <div className="dotgrid-bg">
        <DotGrid
          dotSize={5}
          gap={15}
          baseColor="#271E37"
          activeColor="#5227FF"
          proximity={120}
          shockRadius={250}
          shockStrength={5}
          resistance={750}
          returnDuration={1.5}
        />
      </div>

      {/* Lado izquierdo */}
      <div className="leftHome">

        <p className="leftTitle" style={{ animation: 'fadeSlideUp 0.55s ease both' }}>
          {t.hero.greeting} <span className="highlight">Raúl</span>
        </p>

        <p className="leftTitle" style={{ animation: 'fadeSlideUp 0.55s ease 0.1s both' }}>
          {t.hero.role}
        </p>

        <p className="leftText" style={{ animation: 'fadeSlideUp 0.55s ease 0.2s both' }}>
          {t.hero.description}
        </p>

        <div
          className="flex items-center gap-3 mb-4"
          style={{ animation: 'fadeSlideUp 0.55s ease 0.3s both' }}
        >
          <a
            href="https://github.com/raulfr99"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            style={{ color: 'rgba(255,255,255,0.6)', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#fff'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'}
          >
            <AiFillGithub size={44} />
          </a>
          <a
            href="https://www.linkedin.com/in/raulfr99/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            style={{ color: 'rgba(255,255,255,0.6)', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#0A66C2'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'}
          >
            <AiFillLinkedin size={44} />
          </a>
        </div>

        <div
          className="flex items-center gap-3 flex-wrap"
          style={{ animation: 'fadeSlideUp 0.55s ease 0.35s both' }}
        >
          <Link
            to="contact"
            smooth
            offset={-80}
            duration={100}
            className="workButton"
            style={{ margin: 0, width: 'auto', padding: '0 20px' }}
          >
            {t.hero.cta}
          </Link>
          <a
            href="https://github.com/raulfr99"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2"
            style={{
              padding: '0 16px',
              height: 36,
              borderRadius: 6,
              border: '1px solid rgba(255,255,255,0.15)',
              color: 'rgba(255,255,255,0.55)',
              fontSize: '0.7rem',
              fontWeight: 'bold',
              letterSpacing: '1px',
              textDecoration: 'none',
              fontFamily: 'Manrope, sans-serif',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'
              e.currentTarget.style.color = '#fff'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'
              e.currentTarget.style.color = 'rgba(255,255,255,0.55)'
            }}
          >
            {t.hero.github}
          </a>
        </div>

        <div
          className="mt-8 pt-6 w-full"
          style={{
            borderTop: '1px solid rgba(255,255,255,0.06)',
            animation: 'fadeSlideUp 0.55s ease 0.5s both',
          }}
        >
          <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.2)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 10, fontFamily: 'Manrope, sans-serif' }}>
            {t.hero.techStack}
          </p>
          <div className="flex flex-wrap gap-2">
            {STACK.map((s, i) => (
              <StackPill key={i} {...s} delay={600 + i * 60} />
            ))}
          </div>
        </div>

      </div>

      {/* Lado derecho */}
      <div className="rightHome">
        <div className="gradient" />
        <Lottie animationData={anTest} loop className="animatedIcon" />
      </div>

      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>

    </div>
  )
}

export default Page
